var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addActiveCode-container" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "40%",
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleCodeClose
          }
        },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "500px" } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    rules: _vm.rules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活码名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          size: "mini",
                          maxlength: "20",
                          "show-word-limit": "",
                          placeholder: "请输入名称"
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "使用场景：", prop: "sceneName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          size: "mini",
                          maxlength: "20",
                          "show-word-limit": "",
                          placeholder: "请输入使用场景"
                        },
                        model: {
                          value: _vm.form.sceneName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "sceneName", $$v)
                          },
                          expression: "form.sceneName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "扫码标签：", prop: "tagList" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-plus"
                          },
                          on: { click: _vm.addTag }
                        },
                        [_vm._v(" 添加标签 ")]
                      )
                    ],
                    1
                  ),
                  _vm.form.tagList && _vm.form.tagList.length
                    ? _c(
                        "el-form-item",
                        _vm._l(_vm.form.tagList, function(tag, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticStyle: { margin: "5px" },
                              attrs: { size: "mini" }
                            },
                            [_vm._v(" " + _vm._s(tag.tagName) + " ")]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "添加群聊：", prop: "chatList" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                disabled: _vm.row && _vm.row.id ? true : false,
                                icon: "el-icon-plus"
                              },
                              on: { click: _vm.addGroup }
                            },
                            [_vm._v(" 选择群聊 ")]
                          ),
                          _vm.form.chatList && _vm.form.chatList.length
                            ? _c(
                                "div",
                                [
                                  _vm._v(" 已选： "),
                                  _vm._l(_vm.form.chatList, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index,
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: {
                                          size: "mini",
                                          closable:
                                            _vm.row && _vm.row.id ? false : true
                                        },
                                        on: {
                                          close: function($event) {
                                            return _vm.handleTagDelete(item)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(item.chatName || "--"))]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "grop-tip" }, [
                            _vm._v("*单个群人数上限200")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "自动建群：", prop: "autoCreateRoomFlag" }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            "true-label": 1,
                            "false-label": 0,
                            disabled: _vm.row && _vm.row.id ? true : false
                          },
                          on: { change: _vm.autoCreateRoomFlagChange },
                          model: {
                            value: _vm.form.autoCreateRoomFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "autoCreateRoomFlag", $$v)
                            },
                            expression: "form.autoCreateRoomFlag"
                          }
                        },
                        [_vm._v("开启")]
                      ),
                      _c("span", { staticStyle: { color: "#afafaf" } }, [
                        _vm._v(" *开启后，会在群满后自动建群 ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: " ",
                        prop: "roomBaseName",
                        rules: {
                          required: _vm.form.autoCreateRoomFlag == 1,
                          message: "请输入群名前缀",
                          trigger: "blur"
                        }
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          size: "mini",
                          placeholder: "请输入群名前缀",
                          disabled: _vm.row && _vm.row.id ? true : false,
                          maxlength: "20"
                        },
                        model: {
                          value: _vm.form.roomBaseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "roomBaseName", $$v)
                          },
                          expression: "form.roomBaseName"
                        }
                      }),
                      _c("span", { staticStyle: { color: "#afafaf" } }, [
                        _vm._v(" *系统会按照前缀为新建的群依次命名 ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: " ",
                        prop: "roomBaseId",
                        rules: {
                          required: _vm.form.autoCreateRoomFlag == 1,
                          message: "请输入起始序号",
                          trigger: "blur"
                        }
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          size: "mini",
                          placeholder: "请输入起始序号",
                          disabled: _vm.row && _vm.row.id ? true : false,
                          maxlength: "8"
                        },
                        on: {
                          input: function($event) {
                            return _vm.numberInput("roomBaseId")
                          }
                        },
                        model: {
                          value: _vm.form.roomBaseId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "roomBaseId", $$v)
                          },
                          expression: "form.roomBaseId"
                        }
                      }),
                      _c("span", { staticStyle: { color: "#afafaf" } }, [
                        _vm._v(" *新建的第一个群起始序号，后面会依次+1 ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效期至：", prop: "expireTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "timestamp",
                          type: "date",
                          placeholder: "选择日期",
                          size: "mini",
                          "picker-options": _vm.expirationTimePickerOptions
                        },
                        model: {
                          value: _vm.form.expireTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "expireTime", $$v)
                          },
                          expression: "form.expireTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    loading: _vm.btnLoading
                  },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.addTagsShow
        ? _c("AddTags", {
            ref: "AddTagsRef",
            on: {
              getSelectedTage: _vm.getSelectedTage,
              closeTageDia: _vm.closeTageDia
            }
          })
        : _vm._e(),
      _vm.addGroupShow
        ? _c("AddGroup", {
            ref: "AddGroupRef",
            on: {
              getSelectedGroup: _vm.getSelectedGroup,
              closeGroupDia: _vm.closeGroupDia
            }
          })
        : _vm._e(),
      _vm.tagVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "添加标签",
                visible: _vm.tagVisible,
                "close-on-click-modal": false,
                width: "30%",
                "close-on-press-escape": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.tagVisible = $event
                }
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择", size: "small" },
                  model: {
                    value: _vm.uid,
                    callback: function($$v) {
                      _vm.uid = $$v
                    },
                    expression: "uid"
                  }
                },
                _vm._l(_vm.tagList, function(item) {
                  return _c("el-option", {
                    key: item.groupId,
                    attrs: { label: item.groupName, value: item.groupId }
                  })
                }),
                1
              ),
              _c(
                "div",
                { staticStyle: { margin: "30px 0" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.checkList,
                        callback: function($$v) {
                          _vm.checkList = $$v
                        },
                        expression: "checkList"
                      }
                    },
                    [
                      _vm._l(_vm.tagItemList, function(i, index) {
                        return [
                          _c("el-checkbox", { attrs: { label: i.tagId } }, [
                            _vm._v(_vm._s(i.tagName))
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.handleTags }
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }